<template>
    <div id="attorney-dispute-note-association-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="attorney-dispute-note-association-modal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Link Claim Note</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <div v-if="note">
                        {{ note.text }} 
                        <div class="d-flex flex-row-reverse border-bottom">
                            <div class="text-muted pb-3 pr-3">
                                <small>{{ note.user.first_name + ' ' + note.user.last_name + ' - ' }}{{ note.created_at | localizeTime('lll') }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="text-muted font-italic mt-2">Select a Form 1008 to link the document to:</div>
                    <table class="table table-sm border-none-top table-font-size px-0">
                        <thead>
                            <tr>
                                <th class="fit"></th>
                                <th class="fit">Docket Number</th>
                                <th>Description</th>
                                <th class="fit">Owner</th>
                                <th class="fit">Created</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doc in documents" :key="'attorney-dispute-association-' + doc.id">
                                <td class="fit">
                                    <div class="custom-control custom-checkbox">
                                        <input :id="'dispute-association-checkbox-' + doc.id" type="checkbox" class="custom-control-input" v-model="doc.selected" :disabled="doc.disabled">
                                        <label class="custom-control-label align-top" :for="'dispute-association-checkbox-' + doc.id">
                                            <span class="sr-only"></span>
                                        </label>
                                    </div>
                                </td>
                                <td class="fit">{{ doc.docket_number }}</td>
                                <td class="text-truncate">{{ doc.description }}</td>
                                <td class="fit">{{ doc.created_by.last_name }}</td>
                                <td class="fit">{{ doc.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                            </tr>
                        </tbody>  
                    </table>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="associate()">OK</button>
                    <button class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() {
        return {
            claimId: null,
            note: null,
            documents: [],
            id: null
        }
    },
    methods: {
        show: function (claimId, note) {

            this.claimId = claimId;
            this.note = note;

            axios.get('/ajax/attorney/claims/' + claimId + '/notes/' + note.id + '/associations')
            .then(response => {

                this.documents = response.data.documents;
                $('#attorney-dispute-note-association-modal').modal('show'); 
            })
            .catch(error => {
                // TODO: handle errors
                console.log(error);
            });
        },
        associate: function () {

            axios.post('/ajax/attorney/claims/' + this.claimId + '/notes/' + this.note.id + '/associate', { 
                dispute_ids: this.documents.filter(x => !x.disabled && x.selected).map(y => y.id)
            })
            .catch(error => {
                toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
            });

            $('#attorney-dispute-note-association-modal').modal('hide');
        }
    },
    created() {
        eventHub.$on('show-attorney-dispute-note-association', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-attorney-dispute-note-association');
    }    
}
</script>

<style scoped>
    .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: #adb5bd !important;
        border: 1px solid #adb5bd !important;
    }
</style>